/** Load magic-cursor after first pointer activity (desktop only). */

let scheduled = false;

function shouldLoadMagicCursor() {
	return document.body.classList.contains('tt-magic-cursor')
		&& !document.body.classList.contains('is-mobile')
		&& window.innerWidth > 1024;
}

function loadMagicCursor() {
	if (document.documentElement.classList.contains('tt-vt-navigation')) {
		window.addEventListener('tt:transition-complete', () => {
			import('./magic-cursor.js');
		}, { once: true });
		return;
	}

	import('./magic-cursor.js');
}

function scheduleMagicCursorLoad() {
	if (scheduled || !shouldLoadMagicCursor()) {
		return;
	}

	scheduled = true;
	const opts = { once: true, passive: true, capture: true };

	window.addEventListener('pointermove', loadMagicCursor, opts);
	window.addEventListener('mousemove', loadMagicCursor, opts);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', scheduleMagicCursorLoad, { once: true });
} else {
	scheduleMagicCursorLoad();
}
